// Local dependencies.
import {
  HomePageData,
  HomePageQueryArgs,
  PriceElasiticitiesData,
  CannibalizationData,
  PriceElasticitiesDataQueryArgs,
} from "types/homePage";
import { emptySplitApi } from "../api/emptySplitApi";
import { HOMEPAGE_DATA_API_URL, PRICE_ELASTICITIES_DATA, CANNIBALIZATION_DATA } from "constants/apiEndpoints";

// Define service slice and endpoints.
const homePageDataApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getHomePageData: builder.query<HomePageData, Partial<HomePageQueryArgs>>({
      query: (queryArg) => ({
        url: HOMEPAGE_DATA_API_URL,
        method: "POST",
        body: queryArg,
      }),
      providesTags: ["HomePageData"],
    }),
    getPriceElasticitiesData: builder.query<PriceElasiticitiesData, Partial<PriceElasticitiesDataQueryArgs>>({
      query: (queryArg) => ({
        url: PRICE_ELASTICITIES_DATA,
        method: "POST",
        body: queryArg,
      }),
      providesTags: ["PriceElasticitiesData"],
    }),
    getCannibalizationData: builder.query<CannibalizationData, Partial<PriceElasticitiesDataQueryArgs>>({
      query: (queryArg) => ({
        url: CANNIBALIZATION_DATA,
        method: "POST",
        body: queryArg,
      }),
      providesTags: ["PriceElasticitiesData"],
    }),
  }),
  overrideExisting: false,
});

// Define hooks.
const {
  useGetHomePageDataQuery,
  useLazyGetHomePageDataQuery,
  useGetPriceElasticitiesDataQuery,
  useLazyGetPriceElasticitiesDataQuery,
  useGetCannibalizationDataQuery,
  useLazyGetCannibalizationDataQuery,
} = homePageDataApi;

// Export slice and hooks.
export {
  homePageDataApi,
  useGetHomePageDataQuery,
  useLazyGetHomePageDataQuery,
  useGetPriceElasticitiesDataQuery,
  useLazyGetPriceElasticitiesDataQuery,
  useGetCannibalizationDataQuery,
  useLazyGetCannibalizationDataQuery,
};
